import React, { useEffect, useState } from "react";
import { Image, Paper, Text } from "@mantine/core";
import QRCode from "qrcode";

interface CourseCompletionProps {
  name: string;
  courseName: string;
  startDate: string;
  completionDate: string;
  certificateNumber: string;
}

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

const CourseCompletion: React.FC<CourseCompletionProps> = ({
  name,
  courseName,
  startDate,
  completionDate,
  certificateNumber,
}) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>("");

  const generateQRCode = async (certificateNumber: string): Promise<string> => {
    try {
      const verificationUrl = `https://thinkcloudly.com/cert-verification?cert=${certificateNumber}`;
      const qrCodeDataUrl = await QRCode.toDataURL(verificationUrl, {
        width: 100,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
      return qrCodeDataUrl;
    } catch (error) {
      console.error('Error generating QR code:', error);
      return '';
    }
  };

  useEffect(() => {
    if (certificateNumber) {
      generateQRCode(certificateNumber).then(setQrCodeDataUrl);
    }
  }, [certificateNumber]);

  return (
    <Paper style={{ width: "210mm", height: "147mm", position: "relative" }}>
      {/* Background Image */}
      <Image
        src="https://ik.imagekit.io/2fljt9khj/1.png?updatedAt=1749652978442"
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
        alt="Certificate Background"
      />

      {/* Content */}
      <div
        style={{
          position: "absolute",
          top: "40mm",
          left: 0,
          right: 0,
          bottom: "20mm",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20mm",
          boxSizing: "border-box",
          color: "#221E45",
          textAlign: "center",
        }}
      >
        {/* Certificate Header */}
        <div style={{ marginBottom: "30mm", flexGrow: 1 }}>
          <Text style={{ fontSize: "30px", fontWeight: "bold", marginTop: "40px" }}>
            {name}
          </Text>
          <Text style={{ fontSize: "15px", marginTop: "34px" }}>
            {courseName}
          </Text>
          <Text style={{ fontSize: "11px", marginTop: "3px", marginRight: "-120px" }}>
            <strong></strong> {formatDate(startDate)} To {formatDate(completionDate)}
          </Text>
        </div>

        {/* Date and Signature */}
        <div style={{ marginTop: "auto", marginBottom: "20mm" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Add any additional elements like signature or date here */}
          </div>
        </div>
      </div>

      {/* QR Code - Positioned similar to CertificateGenerator */}
      {qrCodeDataUrl && certificateNumber && (
        <div
          style={{
            position: "absolute",
            bottom: "55px",
            left: "75px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img
            src={qrCodeDataUrl}
            alt="QR Code"
            style={{
              width: "90px",
              height: "90px",
              border: "1px solid #ccc",
            }}
          />
        </div>
      )}

      {/* Certificate Number and Issue Date */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "28px",
          display: "flex",
          flexDirection: "column",
          gap: "2px",
        }}
      >
        <Text
          style={{
            fontSize: "10px",
            whiteSpace: "nowrap",
            fontWeight: "normal",
            color: "rgb(51, 51, 51)",
          }}
        >
          Issued On: {formatDate(completionDate)}
        </Text>
        {certificateNumber && (
          <Text
            style={{
              fontSize: "11px",
              fontWeight: "400",
              color: "rgb(51, 51, 51)",
            }}
          >
            Certificate No: {certificateNumber}
          </Text>
        )}
      </div>
    </Paper>
  );
};

export default CourseCompletion;